export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  });
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function formatNumber(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return n.toLocaleString('de-DE');
}

export function formatPercent(numerator: number, denominator: number): string {
  if (!denominator) return '0,0 %';
  return ((numerator / denominator) * 100).toLocaleString('de-DE', {
    minimumFractionDigits: 1, maximumFractionDigits: 1,
  }) + ' %';
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'draft':     return 'Entwurf';
    case 'pending_approval': return 'Wartet auf Freigabe';
    case 'scheduled': return 'Geplant';
    case 'sending':   return 'Wird gesendet';
    case 'sent':      return 'Versendet';
    case 'failed':    return 'Fehler';
    case 'archived':  return 'Archiviert';
    default:          return status;
  }
}

export function roleLabel(role: string): string {
  switch (role) {
    case 'admin':              return 'Administrator';
    case 'redakteur':          return 'Redaktion';
    case 'geschaeftsfuehrung': return 'Geschäftsführung';
    case 'studio_leiter':      return 'Studioleitung';
    case 'viewer':             return 'Betrachter';
    default:               return role;
  }
}
